export const H5 = ({ children = null, className = "", ...rest }) => (
  <div
    data-testid="H5"
    className={`H5 maax-font-weight-bold ${className}`}
    style={{
      fontSize: `18px`,
      lineHeight: `1.28`,
      color: `#67696d`,
    }}
    {...rest}
  >
    {children}
  </div>
)

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// H5.propTypes = {
//   children: PropTypes.node,
//   className: PropTypes.string,
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// H5.defaultProps = {
//   children: null,
//   className: "",
// }
